import { queryKey } from 'Shared/const/queryKey';
import type { GetPointCalenderResponse } from 'viewup-api/v2';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import type { ViewingMoneyQueryKey } from './queries';

interface PointCalenderProps {
  query: {
    monthValue: number;
    pointType?: 'plus' | 'minus';
    yearValue: number;
  };
}

export const useGetCalender = (
  { query }: PointCalenderProps,
  params?: QueryParam<
    GetPointCalenderResponse,
    unknown,
    GetPointCalenderResponse,
    ViewingMoneyQueryKey['calender']['queryKey']
  >,
) => {
  const queryResult = useSDQuery<
    GetPointCalenderResponse,
    unknown,
    GetPointCalenderResponse,
    ViewingMoneyQueryKey['calender']['queryKey']
  >({
    ...params?.options,
    ...queryKey.viewingMoney.calender({
      monthValue: query.monthValue,
      yearValue: query.yearValue,
    }),
  });

  return queryResult;
};
